import React from "react";
import Edit from "@mui/icons-material/Edit";
import { InputAdornment } from "@mui/material";
function LabelIcon({
  value,
  type,
  params,
  setOpen,
  editMode,
  setParamsID,
  setItemName,
  setItemType,
  itemType,
}) {
  return (
    <InputAdornment position="end">
      <span
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          if (editMode === true) {
            setParamsID(value);
            setOpen(true);
            if (setItemName) {
              setItemName("");
            }
            if (setItemType) {
              setItemType(itemType);
            }
          }
        }}
      >
        {value === "" || value === 0 || value === undefined ? (
          // <CheckIcon sx={{ color: "danger.main", fontSize: "18px" }} />
          ""
        ) : editMode === true ? (
          <Edit
            sx={{ color: "#6096d9", fontSize: "14px", cursor: "pointer" }}
          />
        ) : (
          ""
        )}
      </span>
      <span>{type === "Accounts" && params}</span>
    </InputAdornment>
  );
}

export default LabelIcon;
